<template>
    <ExternalQueryList
        endpoint="/api/v2/users"
        :headlines="headlines"
        :filters="filters"
        :can-destroy="() => true"
        :can-update="() => true"
        :get-row-class="user => !user.attributes.is_active ? 'warning' : ''"
        @show="user => $router.push(getUrl(user))"
    >
        <template v-slot:default="{ row: user }">
            <td>
                <router-link :to="getUrl(user)">
                    {{ user.attributes.first_name }} {{ user.attributes.last_name }}
                </router-link>

                <span v-if="user.attributes.is_default_subscription_responsible" class="label label-info">
                    Default Subscription Responsible
                </span>
            </td>

            <td>
                {{ user.attributes.email }}
            </td>
        </template>
    </ExternalQueryList>
</template>

<script>
import ExternalQueryList from '../../../Panels/Lists/ExternalQuery'

export default {
    components: {ExternalQueryList},

    computed: {
        headlines() {
            return [
                {width: 11, text: 'Name', sort_column: 'first_name'},
                {width: 11, text: 'Email', sort_column: 'email'}
            ]
        },

        filters() {
            return [
                [
                    {
                        width: 20,
                        widget: 'text',
                        name: 'search',
                        placeholder: 'Search...'
                    },
                    {
                        width: 4,
                        widget: 'submit'
                    }
                ]
            ]
        }
    },

    methods: {
        getUrl(user) {
            return '/users/' + user.id + '/edit'
        }
    }
}
</script>
